import { UserInputDto } from 'src/app/users/dtos/user-input.dto';
import { OrganizationInputDto } from 'src/app/public-utility/organization/dtos/organization-input.dto';

export class OrganizationWithInitialUserInput extends OrganizationInputDto {
  owner: UserInputDto;
}
